import { render } from "./faq.md?vue&type=template&id=590f952e"
import script from "./faq.md?vue&type=script&lang=js"
export * from "./faq.md?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__